import { WEEKDAYS } from './form'
import { type GameCriteriaFormData } from './types'
import { type BoostMultiplier, isNotEmpty } from '@terros/common'

export const getBoostMultiplier = (values: GameCriteriaFormData): BoostMultiplier | undefined => {
  const { boostDays, boostMultiplier, boostEnabled } = values
  if (!boostEnabled) return
  return {
    days: toDays(boostDays),
    multiplier: boostMultiplier,
  }
}

type DayNumber = 1 | 2 | 3 | 4 | 5 | 6 | 7

const toDays = (days?: string[]): DayNumber[] => {
  if (!days) return []
  const numbers = days.map((d) => (WEEKDAYS.indexOf(d) + 1) as DayNumber)
  return numbers.filter(isNotEmpty).sort((a, b) => a - b)
}

export const getBoosterText = (boostMultiplier: BoostMultiplier): string => {
  if (!boostMultiplier) return ''
  return `Booster: ${boostMultiplier.multiplier}x on ${getDays(boostMultiplier.days)}`
}

const getDays = (days: number[]): string => {
  if (days.length === 7) return 'Every day'

  return days
    .map((d) => {
      return WEEKDAYS[d - 1]
    })
    .join(', ')
}
